"use strict";

require("@patsnap-biz/icon/lib/style");
require("@patsnap-biz/virtual-tree/lib/style");
require("@patsnap-biz/design-tokens/scss/_el-tooltip.scss");
require("@patsnap-biz/design-tokens/scss/_input.scss");
require("element-ui/lib/theme-chalk/tooltip.css");
require("element-ui/lib/theme-chalk/date-picker.css");
require("element-ui/lib/theme-chalk/popover.css");
require("element-ui/lib/theme-chalk/input.css");
require("./index.scss");